import * as TabsPrimitive from '@radix-ui/react-tabs'
import React from 'react'
import { cn } from '../lib/utils'

export const Tabs = TabsPrimitive.Root

interface TabsListProps {
    children: React.ReactNode
    className?: string
}

export const TabsList: React.FC<TabsListProps> = ({ children, className = '' }) => {
    return (
        <TabsPrimitive.List
            className={cn(
                'flex h-10 w-full max-w-full items-center justify-start gap-1 overflow-x-auto rounded-full bg-secondary p-1 text-muted-foreground sm:inline-flex sm:w-auto sm:justify-center',
                className
            )}
        >
            {children}
        </TabsPrimitive.List>
    )
}

interface TabsTriggerProps {
    children: React.ReactNode
    value: string
    className?: string
    disabled?: boolean
}

export const TabsTrigger: React.FC<TabsTriggerProps> = ({
    children,
    value,
    className = '',
    disabled = false
}) => {
    return (
        <TabsPrimitive.Trigger
            value={value}
            disabled={disabled}
            className={cn(
                'inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-semibold text-muted-foreground transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                'data-[state=active]:bg-primary data-[state=active]:text-primary-foreground',
                disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
                className
            )}
        >
            {children}
        </TabsPrimitive.Trigger>
    )
}

interface TabsContentProps {
    children: React.ReactNode
    value: string
    className?: string
}

export const TabsContent: React.FC<TabsContentProps> = ({
    children,
    value,
    className = ''
}) => {
    return (
        <TabsPrimitive.Content value={value} className={cn('mt-4', className)}>
            {children}
        </TabsPrimitive.Content>
    )
}
